import React from "react";
import AddToCalendar from 'react-add-to-calendar';
import './AddToCalender.scss';
export default function AddToCalender({
  title,
  description,
  location,
  startTime,
  endTime
}: any) {

  return (
    <div className="comfort-btn" >
      <AddToCalendar
        event={{
          title: title,
          description: description,
          location: location,
          startTime: startTime,
          endTime: endTime
        }} 
      />
    </div>);


};